<spw-topbar>
    <div slot="logo">Coffee Club</div>
    <!-- <div slot="baseline">Application d'inventaire</div> -->
    <div slot="right"></div>
</spw-topbar>


<div class="layout">
  <spw-sidebar [defaultExpanded]="false">
    <div slot="navigation-top">
      <spw-sidebar-navigation-item
        icon="fa-house"
        iconVariant="fa-solid"
        tooltipTitle="Accueil"
        [active]="isActive('/home')"
        (click)="navigate('/home')"
      >
        Accueil
      </spw-sidebar-navigation-item>

      <spw-sidebar-navigation-item
        icon="fa-user"
        iconVariant="fa-solid"
        tooltipTitle="Mes infos"
        [active]="isActive('/me')"
        (click)="navigate('/me')"
      >
        Mes infos
      </spw-sidebar-navigation-item>

      <spw-sidebar-navigation-item
        icon="fa-clock-rotate-left"
        iconVariant="fa-solid"
        tooltipTitle="Historique"
        [active]="isActive('/history')"
        (click)="navigate('/history')"
      >
        Historique
      </spw-sidebar-navigation-item>

      @if (authService.isAdmin()) {
        <spw-sidebar-navigation-separator></spw-sidebar-navigation-separator>

        <spw-sidebar-navigation-item
          icon="fa-layer-group"
          iconVariant="fa-solid"
          tooltipTitle="Admin - Plateaux"
          [active]="isActive('/admin/plateaux')"
          (click)="navigate('/admin/plateaux')"
        >
          Plateaux
        </spw-sidebar-navigation-item>

        <spw-sidebar-navigation-item
          icon="fa-users"
          iconVariant="fa-solid"
          tooltipTitle="Admin - Utilisateurs"
          [active]="isActive('/admin/users')"
          (click)="navigate('/admin/users')"
        >
          Utilisateurs
        </spw-sidebar-navigation-item>

        <spw-sidebar-navigation-item
          icon="fa-envelope"
          iconVariant="fa-solid"
          tooltipTitle="Admin - Emails"
          [active]="isActive('/admin/emails')"
          (click)="navigate('/admin/emails')"
        >
          Emails
        </spw-sidebar-navigation-item>
      }
    </div>

    <div slot="navigation-bottom">
      <spw-sidebar-navigation-separator></spw-sidebar-navigation-separator>

      <spw-sidebar-navigation-item
        icon="fa-right-from-bracket"
        iconVariant="fa-solid"
        tooltipTitle="Déconnexion"
        (click)="logout()"
      >
        Déconnexion
      </spw-sidebar-navigation-item>
    </div>
  </spw-sidebar>

  <main class="layout__content">
    <router-outlet />
  </main>
</div>

<spw-footer>
    <spw-footer-bottom site-title="Coffee Club">
        <span>Réalisé par Renaud Phillipart &amp; Julien Moors</span>
        <spw-footer-link href="#ITSM">Support</spw-footer-link>
    </spw-footer-bottom>
</spw-footer>
